<template>
  <div id="summary-screen">
    <!-- v-html="
        $t(`deliveryScreen.summaryScreen.mainText.${moveType}`, {
          partnerName: getPartner.partner.name
        })
      " -->
    <div class="main-text">
      <summary-main-text :moving="moveType" :partner="getPartner.partner" />
    </div>
    <div class="readed-qr-codes" v-if="!loadingData">
      <div class="qr-title">
        {{ $t("summaryScreen.qrItem.title") }}
      </div>
      <div class="type-count" v-if="readedBoxesInfo.types">
        <div
          class="type-a"
          v-html="
            $t('storeScreen.boxTypes.typeA', {
              count: readedBoxesInfo.types['0']
            })
          "
        ></div>
        <div
          class="type-b"
          v-html="
            $t('storeScreen.boxTypes.typeB', {
              count: readedBoxesInfo.types['1']
            })
          "
        ></div>
        <div
          class="type-c"
          v-html="
            $t('storeScreen.boxTypes.typeC', {
              count: readedBoxesInfo.types['2']
            })
          "
        ></div>
      </div>
      <div class="divider"></div>
      <div class="readed-boxes">
        <ul class="readed-boxes-list">
          <li
            v-for="(item, index) in this.readedBoxesInfo.readedBoxes"
            :key="index"
            v-html="
              $t('summaryScreen.qrItem', {
                code: item.code,
                type: $variables.boxTypes[item.type],
                qrCode: item.QRNumber
              })
            "
          ></li>
        </ul>
        <template v-if="readedBoxesInfo.notFoundBoxes.length > 0">
          <div class="not-found-qr-title">
            {{ $t("summaryScreen.notFoundQRItem.title") }}
          </div>
          <ul class="not-found-boxes-list">
            <li
              v-for="(item, index) in this.readedBoxesInfo.notFoundBoxes"
              :key="index"
              v-html="
                $t('summaryScreen.notFoundQRItem', {
                  qrCode: item
                })
              "
            ></li>
          </ul>
        </template>
      </div>
    </div>
    <template v-else>
      <div class="loading-screen">
        <loader-ring />
      </div>
    </template>
  </div>
</template>

<script>
import SummaryMainText from "@/components/shared/Summary/SummaryMainText";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SummaryScreen",
  props: {},
  components: {
    SummaryMainText
  },
  data: () => ({
    readedBoxes: [],
    loadingData: false
  }),
  created() {
    this.getReadedBoxes().then(() => {
      this.boxesTypesWithCount();
    });
  },
  computed: {
    ...mapGetters({
      getPartner: "moving/getPartner",
      getQR: "moving/getQR"
    }),
    moveType() {
      return this.getPartner.moved;
    },
    readedBoxesInfo() {
      const data = {};
      data["readedBoxes"] = this.readedBoxes;
      data["notFoundBoxes"] = this.getNotFoundBoxes();
      data["types"] = this.boxesTypesWithCount();
      return data;
    }
  },
  methods: {
    ...mapActions({
      readBoxesByQR: "boxes/readBoxesByQR"
    }),
    getReadedBoxes() {
      return new Promise(resolve => {
        this.loadingData = true;
        this.readBoxesByQR(this.getQR)
          .then(res => {
            this.readedBoxes = res.data;
            this.loadingData = false;
            resolve();
          })
          .catch(() => {
            this.loadingData = false;
          });
      });
    },
    getBoxType(item) {
      if (item >= 1000 && item < 2000) {
        return this.$variables.boxTypes[0];
      } else if (item >= 2000 && item < 3000) {
        return this.$variables.boxTypes[1];
      } else if (item >= 3000) {
        return this.$variables.boxTypes[2];
      } else {
        return "N/A";
      }
    },
    getNotFoundBoxes() {
      return this.getQR.filter(item => {
        return !this.readedBoxes.some(box => {
          return box.QRNumber == item;
        });
      });
    },
    boxesTypesWithCount() {
      const types = { 0: 0, 1: 0, 2: 0 };

      this.readedBoxes.forEach(element => {
        types[element["type"]]++;
      });
      return types;
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
  }
};
</script>

<style lang="scss" scoped>
#summary-screen {
  margin: auto;
  max-width: 500px;
  .main-text {
    margin-bottom: 40px;
  }
  .readed-qr-codes {
    margin-bottom: 30px;
    .qr-title {
      font-size: 20px;
      font-weight: 550;
    }
    .type-count {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      div {
        padding-left: 10px;
        padding-right: 10px;
        border-right: 1px solid black;
      }
      div:first-of-type {
        padding-left: 0px;
      }
      div:last-of-type {
        padding-right: 0px;
        border-right: none;
      }
    }
    li {
      font-size: 16px;
      line-height: 25px;
    }
    .not-found-qr-title {
      color: red;
    }
    .not-found-boxes-list {
      margin-top: 2px;
      li {
        color: red;
      }
    }
  }
  .loading-screen {
    display: flex;
    justify-content: center;
  }
}
</style>
